import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Plot from 'react-plotly.js';
import { selectUser } from '../../reducers/userSlice';
import { chartColors } from '../../helpers/chartColors';
import { useTheme } from '@mui/styles';

export const RTFOSeismicityHistogramChart = ({ currentRTFOName, gutenbergRichterResult, gridView=true }) => {

  const theme = useTheme();
  const user = useSelector(selectUser);

  const darkMode = user?.value?.darkMode;

  const layout ={
    yaxis: { // number of events y axis
      linecolor: darkMode ? 'lightgrey' : 'black',
      gridcolor: darkMode ? 'grey' : 'lightgrey',
      color: darkMode ? 'lightgrey' : 'black',
      title: {
        text: 'Number of Events',
        font: {
          size: 12
        },
      },
      rangemode: 'nonnegative',
      zeroline: false
    },
    xaxis: { // magnitude x axis
      title: {
        text: 'Magnitude of Events (ML)',
        font: {
          size: 12
        }
      },
      linecolor: darkMode ? 'lightgrey' : 'black',
      gridcolor: darkMode ? 'grey' : 'lightgrey',
      color: darkMode ? 'lightgrey' : 'black',
      zeroline: false,
      type: 'category'
    },
    hovermode: "closest",
    autosize: true,
    showlegend: true,
    legend: {
      orientation: "h",
      yanchor: "top",
      font: {
        color: darkMode ? 'lightgrey' : 'grey'
      },
      y: -0.2
    },
    shapes: [ 
      
    ],
    annotations: [
      {
        text: "Magnitude Histogram",
          font: {
          size: 14,
           color: darkMode ? 'lightgrey' : 'black'
        },
        showarrow: false,
        align: 'center',
        x: 0.5, //position in x domain
        y: (gridView ? 1.15 : 1.075), //position in y domain
        xref: 'paper',
        yref: 'paper',
      },
      {
        text: `Pad: ${currentRTFOName}`,
          font: {
          size: 10,
           color: darkMode ? 'lightgrey' : 'black'
        },
        showarrow: false,
        align: 'center',
        x: 0.5, //position in x domain
        y: (gridView ? 1.09 : 1.035), //position in y domain
        xref: 'paper',
        yref: 'paper',
      },
    ],
    uirevision: true,
    margin: {"t": 60, "l": 60, "r": 60, "b": 50},
    images: [
      {
        x: (gridView ? 0.05 : 0.035),
        y: (gridView ? 1.05 : 1.025),
        sizex: (gridView ? 0.1 : 0.05),
        sizey: 0.1,
        source: process.env.PUBLIC_URL + `/img/ssd_logomark_chart_${darkMode ? 'white' : 'primary'}.png`,
        xref: "page",
        yref: "page",
        xanchor: "right",
        yanchor: "bottom",
        opacity: 0.75
      }
    ],
    plot_bgcolor: "transparent",
    paper_bgcolor: theme?.palette?.elevationOne?.[(darkMode ? 'dark' : 'light')]
  };


  const data = useMemo(() => {
    try {
      // add traces
      let traces = [];

      const X = [];
      const Y = [];

      // plot bins
      const bins = gutenbergRichterResult?.bins;
      for (const bin of bins) {
        X.push(`${bin.binMin?.toFixed(2)}-${bin.binMax?.toFixed(2)}`);
        Y.push(bin.eventsInBin);
      };
      traces.push(
        { // non-cumulative distribution
          x: X,
          y: Y,
          type: 'bar',
          xaxis: 'x1',
          yaxis: 'y1',
          name: 'Bin Histogram',
          marker: {
            size: 8,
            opacity: 1,
            color: chartColors[0]
          },
        }
      );
      return traces;

    } catch (error) {
      console.log(error);
      return [];
    };
  }, [gutenbergRichterResult?.bins]);



  const config = {
    displaylogo: false,
    toImageButtonOptions: {
      format: 'png', // one of png, svg, jpeg, webp
      filename: "RTFO-Gutenberg-" + (new Date().toISOString().split('T')[0]),
      height: 550,
      width: 960,
      scale: 1 // Multiply title/legend/axis/canvas sizes by this factor
    }
  };

  try {
    return (
      <Plot
        data={data}
        layout={layout}
        config={config}
        useResizeHandler={true}
        style={{width: '100%', height: '100%'}}
      />
    );
    
  } catch (error) {
    return <></>;
  };

};

